import type { EncounterRead } from "@/types/emr/encounter/encounter";

export function getDisplayedDoctorAppointment(
  encounter?: Pick<EncounterRead, "status" | "appointment">,
) {
  const canDisplayDoctor =
    encounter?.status === "in_progress" || encounter?.status === "completed";

  if (
    !canDisplayDoctor ||
    !encounter.appointment ||
    encounter.appointment.resource_type !== "practitioner"
  ) {
    return null;
  }

  return encounter.appointment;
}
